let config;

export function initializeAppConfig(ac) {
    if (!config && !!ac) {
        config = ac;
    }

    return config;
}

export function appConfig() {
    return config || {};
}

export default {};
